import { KeycloakService } from "keycloak-angular";
import { environment } from "src/environments/environment";

export function initializer(
  keycloak: KeycloakService
) {
  return () =>
    keycloak.init({
      config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId,
      },
      initOptions: {
        onLoad: 'login-required',
        flow: 'standard'
      }
    });
}